export default function LoadingPage() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0a0c12", flexDirection: "column", gap: 32 }}>
      {/* Mountain logo */}
      <div style={{ animation: "pulse 2s ease-in-out infinite" }}>
        <svg width="64" height="64" viewBox="0 0 28 28" fill="none">
          <path d="M2 22 L10 8 L14 14 L18 10 L26 22 Z" stroke="white" strokeWidth="1.8" strokeLinejoin="round" fill="none"/>
          <path d="M18 10 L22 6 L26 10" stroke="white" strokeWidth="1.8" strokeLinejoin="round" fill="none"/>
        </svg>
      </div>

      {/* Site name */}
      <div style={{ fontFamily: "Geist, sans-serif", fontSize: 22, fontWeight: 700, color: "#fff", letterSpacing: "-0.01em" }}>
        DiscoverSvaneti
      </div>

      {/* Animated dots */}
      <div style={{ display: "flex", gap: 8 }}>
        {[0, 1, 2].map((i) => (
          <div key={i} style={{ width: 8, height: 8, borderRadius: "50%", background: "rgba(255,255,255,0.4)", animation: `dotBounce 1.2s ease-in-out ${i * 0.2}s infinite` }} />
        ))}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(0.95); }
        }
        @keyframes dotBounce {
          0%, 80%, 100% { transform: scale(0.6); opacity: 0.3; }
          40% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
